// src/components/crm/KanbanBoard.js
import React from 'react';
import { db } from '../../firebase/config';
import { doc, updateDoc } from 'firebase/firestore';
import { can, PERMISSIONS } from '../../utils/permissions';

const KanbanBoard = ({ 
    customers,              
    items,                  
    user, 
    currentUserProfile, 
    openModal,
    onStatusChange,         
    statuses = ['New', 'Contacted', 'Proposal Sent', 'Closed', 'Lost'],
    statusColors = {
        'New': 'bg-blue-100',
        'Contacted': 'bg-yellow-100',
        'Proposal Sent': 'bg-purple-100',
        'Closed': 'bg-green-100',
        'Lost': 'bg-red-100'
    }
}) => {
    
    const displayItems = items || customers || [];

    const handleDragStart = (e, itemId) => {
        e.dataTransfer.setData("itemId", itemId);
    };

    const handleDrop = async (e, newStatus) => {
        e.preventDefault();
        const itemId = e.dataTransfer.getData("itemId");

        if (onStatusChange) {
            await onStatusChange(itemId, newStatus);
            return;
        }

        if (itemId && currentUserProfile?.organizationId) {
            try {
                const itemRef = doc(db, `organizations/${currentUserProfile.organizationId}/customers`, itemId);
                await updateDoc(itemRef, { status: newStatus });
            } catch (error) {
                console.error("Failed to update status:", error);
            }
        }
    };

    const allowDrop = (e) => {
        e.preventDefault();
    };

    // FIX: Reverted to CSS Grid for vertical stack on mobile, horizontal on desktop
    return (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {statuses.map(status => (
                <div 
                    key={status} 
                    className={`rounded-lg p-4 ${statusColors[status] || 'bg-gray-100'}`} 
                    onDrop={(e) => handleDrop(e, status)} 
                    onDragOver={allowDrop}
                >
                    <h3 className="font-bold text-lg mb-4 text-gray-800">{status}</h3>
                    <div className="space-y-4 min-h-[100px]">
                        {displayItems.filter(c => c.status === status).map(item => (
                            <div 
                                key={item.id} 
                                draggable 
                                onDragStart={(e) => handleDragStart(e, item.id)} 
                                onClick={() => openModal(item)} 
                                className="bg-white p-4 rounded-md shadow-sm cursor-pointer hover:shadow-lg transition-shadow"
                            >
                                <p className="font-semibold text-gray-800">{item.name}</p>
                                
                                <p className="text-sm text-gray-600">
                                    {item.company || item.role}
                                </p>

                                {/* dealValue is a money figure — hidden from users without VIEW_FINANCIALS (e.g. flag-on techs). */}
                                {can(currentUserProfile, PERMISSIONS.VIEW_FINANCIALS) && item.dealValue > 0 && (
                                    <p className="text-lg font-bold text-green-600 mt-2">
                                        ${Number(item.dealValue).toLocaleString()}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default KanbanBoard;